/* eslint-disable no-undef */
const container = document.querySelector('[data-some-footer-tracking]');

// add a flag to indicate the the script has been loaded
// we use this to check whether we need to manually load the script
// Necessary for some Java apps like innfinn
window.footerLoaded = true;

/* eslint-env browser */
class Footer extends HTMLElement {
    constructor() {
        super();

        this.attachShadow({ mode: 'open' });

        this.shadowRoot.innerHTML += `
            <link
                rel="stylesheet"
                type="text/css"
                href="https://assets.finn.no/pkg/@fabric-ds/css/v1/fabric.min.css"
            />
            <style>
                :host {
                    display: block;
                }
                .pageholder {
                    margin: 0;
                    padding: 0;
                }
                @media (min-width: 1300px) {
                    .pageholder {
                        padding: 0 15px 0;
                        margin: 0 auto;
                    }
                }
                .content {
                    display: -ms-grid;
                    display: grid;
                    -ms-grid-columns: 33.332% 1fr 1fr 1fr 1fr;
                    grid-template-columns: 33.332% 1fr 1fr 1fr 1fr;
                    -ms-grid-rows: auto;
                    grid-template-rows: auto;
                    grid-template-areas:
                        "branding business about privacy support"
                        "divider divider divider divider divider"
                        "social copyrights copyrights copyrights copyrights";
                }

                @media (max-width: 989px) {
                    .content {
                        display: block;
                        margin: 0;
                    }

                    .branding svg {
                        margin: 0 auto 8px;
                    }

                    .details {
                        max-width: 692px;
                    }
                }

                .branding {
                    grid-area: branding;
                }

                .schibsted-logo {
                    min-width: 100px;
                    min-height: 18px;
                    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 154 28' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%2331312F' fill-rule='evenodd'%3E%3Cpath d='M16.96 15c-.1-.21-.26-.52-.49-.81a.78.78 0 00-.61-.32c-.4 0-.67.29-.67.69 0 .14.04.26.1.38l.13.26c.02.04.02.08-.02.1-.04.02-.08 0-.1-.03l-.14-.23a.73.73 0 00-.61-.35.73.73 0 00-.65 1.06l.07.16c.02.04.02.09-.01.1-.04.03-.08 0-.1-.03a5.8 5.8 0 00-.12-.16.66.66 0 00-.54-.28c-.36 0-.66.27-.66.7 0 .12.06.28.12.42.29.65.43 1.29.43 2.27a4.1 4.1 0 01-4 4.19 4.3 4.3 0 01-4.17-2.9.15.15 0 00-.2-.1l-4.3 1.33a.15.15 0 00-.1.2 9.03 9.03 0 008.73 6.28A8.93 8.93 0 0016.95 15m-7.99-.6a.42.42 0 110-.84.42.42 0 010 .84m0-3.58a.42.42 0 110-.84.42.42 0 010 .84m0 1.78a.42.42 0 110-.83.42.42 0 010 .84m3.29 2.02a4.78 4.78 0 00-1.06-.7c-.17-.08-.25-.12-.46-.18-.16-.05-.31-.07-.46 0a.48.48 0 00-.27.58c.05.2.21.28.38.36a5.92 5.92 0 011.17.7c.22.15.5.18.7 0 .22-.2.22-.54 0-.76m1.5-1.05c-.28-.28-.6-.53-.9-.69a1.2 1.2 0 00-.32-.12.53.53 0 00-.53.17.51.51 0 00-.05.6c.1.15.22.23.36.34.22.15.37.27.57.44.14.12.25.24.43.26.23.03.47-.1.57-.3.12-.23.05-.51-.13-.7m-2.62-1.52c-.13-.05-.23-.1-.41-.14a.94.94 0 00-.43-.03.47.47 0 00-.29.72c.08.11.17.16.3.2l.32.12.28.1a.5.5 0 00.44-.14c.26-.25.17-.67-.21-.83m-.43-1.91a1.35 1.35 0 00-.25-.04c-.1-.01-.23 0-.32.07-.2.13-.26.4-.15.6.05.1.14.17.25.2.1.04.21.08.31.1.23.02.45-.13.5-.35.07-.26-.09-.5-.34-.58m2.23.75a1.98 1.98 0 00-.8-.29.53.53 0 00-.54.62c.03.16.14.3.28.37l.33.16c.12.06.24.14.37.17.16.05.34.01.47-.09.3-.24.24-.72-.1-.94m2.36 1.75a3.25 3.25 0 00-.79-.71.69.69 0 00-.5-.1.54.54 0 00-.4.32.54.54 0 00.12.56c.1.11.2.18.3.28.15.13.28.25.41.39.12.12.25.21.43.22.21 0 .42-.11.51-.3a.6.6 0 00-.07-.66'/%3E%3Cpath d='M.96 12.96c.1.22.25.53.48.82.15.19.37.32.62.32.4 0 .67-.3.67-.7a.84.84 0 00-.1-.38l-.13-.25c-.02-.04-.02-.09.01-.1.05-.03.09 0 .11.03l.14.23c.13.2.35.35.61.35a.73.73 0 00.65-1.07l-.08-.16c-.02-.04-.02-.08.02-.1.04-.03.08 0 .1.03l.12.17c.12.17.31.27.53.27.37 0 .67-.27.67-.69 0-.13-.06-.29-.12-.42a5.1 5.1 0 01-.44-2.28 4.1 4.1 0 014-4.18A4.3 4.3 0 0113 7.74c.03.08.11.12.19.1l4.3-1.33a.15.15 0 00.11-.19A9.03 9.03 0 008.87.04 8.93 8.93 0 00.96 12.96m8 4.19a.42.42 0 110 .83.42.42 0 010-.83m0-1.79a.42.42 0 110 .83.42.42 0 010-.83m-3.3-2.03a4.77 4.77 0 001.06.7c.18.08.26.13.47.19.16.04.31.06.45 0 .23-.1.35-.33.28-.59-.05-.2-.21-.28-.39-.36a5.94 5.94 0 01-1.16-.7c-.22-.15-.5-.17-.7 0-.22.2-.22.54 0 .76m-1.5 1.05c.28.29.6.54.9.7.1.05.18.08.32.11a.51.51 0 00.58-.76c-.1-.16-.22-.24-.37-.34a9.01 9.01 0 01-.57-.45c-.13-.11-.24-.23-.42-.26a.57.57 0 00-.58.3.63.63 0 00.14.7m2.62 1.52c.12.06.23.1.4.15.14.03.3.05.44.02a.47.47 0 00.28-.72c-.07-.1-.17-.15-.3-.2l-.3-.11-.3-.1a.5.5 0 00-.43.13c-.26.26-.18.67.2.84m.44 1.9l.24.05c.11 0 .23 0 .33-.08.2-.12.26-.39.15-.6a.46.46 0 00-.25-.2c-.1-.04-.21-.07-.31-.09a.47.47 0 00-.5.35c-.07.26.09.5.34.57m-2.23-.75a1.98 1.98 0 00.8.3c.32.01.6-.3.54-.62a.52.52 0 00-.28-.37l-.33-.17c-.12-.06-.24-.13-.38-.17a.54.54 0 00-.46.1c-.31.24-.25.71.1.93m-2.37-1.74a3.25 3.25 0 00.8.7c.14.1.32.15.5.11a.54.54 0 00.4-.33.54.54 0 00-.12-.56l-.3-.28a7.78 7.78 0 01-.42-.38c-.12-.12-.25-.22-.42-.22a.55.55 0 00-.52.3.6.6 0 00.08.66M49.5 9.61c-1.65 0-3.55.56-4.67 1.9V2.06a.15.15 0 00-.15-.15H40.3a.15.15 0 00-.15.15v25.16c0 .08.07.15.15.15h4.38c.08 0 .15-.07.15-.15V17.21c-.02-1.93 1.1-3.45 3.23-3.45 2.25 0 3.2 1.58 3.2 3.52v9.94c0 .08.07.15.15.15h4.38c.08 0 .15-.07.15-.15V16.47c0-3.8-2.04-6.86-6.44-6.86m12.8-8.12a2.9 2.9 0 00-2.9 2.92c0 1.54 1.3 2.85 2.89 2.85a2.86 2.86 0 002.86-3.22A2.92 2.92 0 0062.3 1.5m2.2 8.57h-4.38a.15.15 0 00-.15.15v17c0 .08.06.15.15.15h4.37c.09 0 .15-.07.15-.15v-17a.15.15 0 00-.15-.15m13.04 13.57c-2.35 0-4.36-1.83-4.36-4.96 0-3.16 2-4.92 4.36-4.92 2.4 0 4.3 1.76 4.3 4.92 0 3.17-1.9 4.96-4.3 4.96m.99-14.03c-2.57 0-4.47 1.13-5.24 2.36v-9.9a.15.15 0 00-.15-.16h-4.3a.15.15 0 00-.16.15v25.16c0 .08.07.15.15.15h4.24c.08 0 .15-.07.15-.15v-1.96c.91 1.48 2.74 2.53 5.13 2.53 4.92 0 8.16-3.9 8.16-9.14 0-5.13-2.92-9.04-7.98-9.04m35.98 13.76c-.3.05-.8.1-1.26.1-1.34 0-2.04-.5-2.04-2v-7.25h3.33c.09 0 .15-.07.15-.15v-3.85a.15.15 0 00-.15-.15h-3.33V5.05a.15.15 0 00-.15-.15h-4.32a.15.15 0 00-.15.15l-.01 5.02h-2.99a.15.15 0 00-.15.15v3.85c0 .08.07.15.15.15h2.98v8.05c0 3.34 2.11 5.35 5.49 5.35a7.2 7.2 0 002.53-.39c.06-.02.1-.08.1-.14v-3.58a.14.14 0 00-.17-.14m30.38.27c-2.47 0-4.3-1.86-4.3-4.96 0-3.09 1.9-4.88 4.3-4.88 2.39 0 4.3 1.75 4.3 4.85 0 3.13-1.91 5-4.3 5m8.68-21.74h-4.35a.15.15 0 00-.15.15v9.73c-.5-.91-1.9-2.14-4.89-2.14-4.89 0-8.3 3.97-8.3 9.03 0 5.24 3.52 9.11 8.44 9.11 2.32 0 4.08-1.05 4.86-2.42v1.85c0 .08.07.15.15.15h4.24c.09 0 .15-.07.15-.15V2.06a.15.15 0 00-.15-.15m-32.22 14.84a3.74 3.74 0 013.87-3.41c2.67 0 3.8 1.69 3.87 3.41h-7.74zm3.8-7.2c-4.43 0-8.51 3.58-8.51 9.1 0 5.84 4.18 9.25 8.93 9.25 3.54 0 6.04-1.73 7.28-4.04a.15.15 0 00-.07-.2l-3.5-1.53a.15.15 0 00-.2.06c-.66 1.03-1.77 1.7-3.47 1.7-2.32 0-4.26-1.65-4.36-3.94h12.23c.08 0 .15-.06.15-.14.02-.25.07-.78.07-1.3 0-5.56-3.2-8.97-8.55-8.97zM97.2 16.84l-2.46-.53c-.95-.17-1.58-.65-1.58-1.5 0-.98.99-1.72 2.22-1.72 1.68 0 2.47.96 2.74 1.87.03.09.12.13.2.1l3.48-1.35a.15.15 0 00.1-.2c-.62-1.8-2.45-3.97-6.56-3.97-3.73 0-6.47 2.57-6.47 5.66 0 2.43 1.51 4.5 4.85 5.24l2.29.53c1.34.28 1.86.84 1.86 1.62 0 .91-.73 1.72-2.28 1.72-1.96 0-2.98-1.17-3.15-2.48a.15.15 0 00-.18-.12l-3.71.81a.15.15 0 00-.12.17c.28 1.98 2.1 5.2 7.2 5.2 4.53 0 6.7-2.88 6.7-5.69 0-2.53-1.71-4.66-5.12-5.36M37.4 22.01l-3.84-1.27a.15.15 0 00-.19.1 3.95 3.95 0 01-3.93 2.77c-2.39 0-4.43-1.76-4.43-4.89s2-4.85 4.4-4.85c1.99 0 3.07 1.08 3.6 2.3.04.08.12.11.2.09l3.92-1.36a.15.15 0 00.1-.19c-.96-2.68-3.58-5.17-7.93-5.17-5.03 0-8.96 3.83-8.96 9.18 0 5.3 4 9.18 9.1 9.18 4.54 0 7.23-2.86 8.05-5.7a.15.15 0 00-.1-.19'/%3E%3C/g%3E%3C/svg%3E");
                }
            </style>
            ${this.innerHTML}
            `;

        this.innerHTML = '';
    }
}

if (!customElements.get('finn-footer')) {
    customElements.define('finn-footer', Footer);
}

const events = {
    facebook: {
        analyticsName: 'other.visit-finn-facebook.click',
        eventFlags: 'start,ltp',
    },
    twitter: {
        analyticsName: 'other.visit-finn-twitter.click',
        eventFlags: 'start,ltp',
    },
    instagram: {
        analyticsName: 'other.visit-finn-instagram.click',
        eventFlags: 'start,ltp',
    },
    youtube: {
        analyticsName: 'other.visit-finn-youtube.click',
        eventFlags: 'start,ltp',
    },
    jobbifinn: {
        analyticsName: 'other.visit-finn-jobbifinn.click',
        eventFlags: 'start,ltp',
    },
    bedriftskunde: {
        analyticsName: 'other.visit-finn-bedriftskunde.click',
        eventFlags: 'start,success',
    },
    admin: {
        analyticsName: 'other.visit-finn-admin.click',
        eventFlags: 'start,success',
    },
    nativeads: {
        analyticsName: 'other.visit-finn-nativeads.click',
        eventFlags: 'start,ltp',
    },
    omfinn: {
        analyticsName: 'other.visit-finn-omfinn.click',
        eventFlags: 'start,ltp',
    },
    personvern: {
        analyticsName: 'other.visit-finn-personvern.click',
        eventFlags: 'start,ltp',
    },
    innstillinger_personvern: {
        analyticsName: 'other.visit-finn-innstillinger-for-personvern.click',
        eventFlags: 'start,ltp',
    },
    cookie: {
        analyticsName: 'other.visit-finn-cookies.click',
        eventFlags: 'start,ltp',
    },
    hjelp: {
        analyticsName: 'other.visit-finn-hjelp.click',
        eventFlags: 'start,ltp',
    },
};

function trackInteraction(evt) {
    if (window.finnAnalytics) {
        const ele = evt.target.closest('[data-some-provider]');
        if (ele) {
            const provider = ele.getAttribute('data-some-provider');
            if (events[provider]) {
                window.finnAnalytics.trackEvent(events[provider]);
            }
        }
    }
}

function isInViewport(elem) {
    const distance = elem.getBoundingClientRect();
    return (
        distance.top >= 0 &&
        distance.left >= 0 &&
        distance.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
        distance.right <=
            (window.innerWidth || document.documentElement.clientWidth)
    );
}

const schibstedBannerKey = 'schibsted-banner-last-viewed';
const oneday = 60 * 60 * 24 * 1000;
const now = +new Date();
const stickyClass = [
    'bottom-0',
    'fixed',
    'w-full',
    'border-solid',
    'border',
    'border-bluegray-300',
    'z-20',
];

function shouldShowBanner() {
    try {
        const lastViewed = parseInt(
            localStorage.getItem(schibstedBannerKey),
            10,
        );
        if (!lastViewed || now - lastViewed > oneday) {
            localStorage.setItem(schibstedBannerKey, now.toString(10));
            return true;
        }
    } catch (e) {
        // Ignore errors from browsers that does not support localStorage.
        if (!(e.message === 'The quota has been exceeded.')) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }
    return false;
}

document.addEventListener('DOMContentLoaded', () => {
    if (shouldShowBanner()) {
        const bannerElement = document
            .querySelector('finn-footer')
            .shadowRoot.querySelector('#schibsted-banner');
        if (bannerElement && !isInViewport(bannerElement)) {
            if (bannerElement.classList) {
                bannerElement.classList.add(...stickyClass);
                setTimeout(() => {
                    if (bannerElement.classList.contains(...stickyClass)) {
                        bannerElement.classList.remove(...stickyClass);
                    }
                }, 8000);
            }
        }
    }
});

if (container) {
    container.addEventListener('click', trackInteraction);
}
